import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import * as yup from 'yup';
import { configure } from "vee-validate";
import Cleave from 'cleave.js';

import en from "./locales/en.json";
import es from "./locales/es.json";

import PreScreenPublic from "./apps/PreScreenPublic.vue";
import { cleave, initValidation } from "./utils/app-init";

// TODO - https://medium.com/i18n-and-l10n-resources-for-developers/the-ultimate-guide-to-vue-localization-with-vue-i18n-bf98b1d40c65
const i18n = createI18n({
    locale: "en",
    fallbackLocale: "es",
    messages: {
        "en": en,
        "es": es,
    },
});

initValidation();

window.onload = function () {
    const app = createApp(PreScreenPublic);
    app.use(i18n);
    app.config.globalProperties.window = window;

    // load cleave
    app.directive('cleave', cleave)

    app.mount("#app");
};
